import { FC, CSSProperties } from 'react'
import React from 'react'

import './DataGrid.less'

import { LeaderboardHeaderRow } from './LeaderboardHeaderRow'
import { DataGridRow } from './DesktopDataGridRow'
import { ShowAllRow } from 'shared/components/ShowAllRow'
import { MobileDataGridRow } from './MobileDataGridRow'
import { setStyle, buildStyles } from 'shared/styleHelpers'

export interface DataGridRowProps {
    data: SortableLeaderboardDataRecord
    rank: number
    leaderboardSettings: LeaderboardSettingsDto
}

export interface StyleProps {
    dataGridHeaderStyle?: CSSProperties
    dataGridEvenStyle?: CSSProperties
    dataGridOddStyle?: CSSProperties
    subTitleStyle?: CSSProperties
    titleStyle?: CSSProperties
}

export interface DataProps {
    data?: SortableLeaderboardDataRecord[]
    leaderboardSettings?: LeaderboardSettingsDto
    overrideDisplayLimit: boolean
    toggleOverrideDisplayLimit: () => void
    showSubTitle: boolean
    showTitle: boolean
    showModule: boolean
    sortLeaderboard: (column: keyof SortableLeaderboardDataRecord) => (sortAscending: boolean) => () => void
    sortedColumn: LeaderboardSort
}

export type LeaderboardDataGridProps = StyleProps & DataProps

export type RenderStylesProps = LeaderboardDataGridProps & { leaderboardSettings: LeaderboardSettingsDto }

export const RenderStyles: FC<RenderStylesProps> = ({ ...props }) => {
    const { scoreboardInstanceSettingsId } = props.leaderboardSettings
    return (
        <>
            {props.titleStyle && setStyle(` .scoreboard-id-${scoreboardInstanceSettingsId} h2 ${buildStyles(props.titleStyle)} `)}
            {props.subTitleStyle && setStyle(`.scoreboard-id-${scoreboardInstanceSettingsId} h3 ${buildStyles(props.subTitleStyle)}`)}
            {props.dataGridHeaderStyle && setStyle(` .scoreboard-id-${scoreboardInstanceSettingsId} .scoreboard-container .data-grid-container .data-grid-row .data-grid-column.column-header ${buildStyles(props.dataGridHeaderStyle)}`)}
            {props.dataGridEvenStyle && setStyle(` .scoreboard-id-${scoreboardInstanceSettingsId} .data-grid-rows .data-grid-row:nth-child(even) .data-grid-cell ${buildStyles(props.dataGridEvenStyle)}`)}
            {props.dataGridOddStyle && setStyle(` .scoreboard-id-${scoreboardInstanceSettingsId} .data-grid-rows .data-grid-row:nth-child(odd) .data-grid-cell ${buildStyles(props.dataGridOddStyle)}`)}
            {
                (props.leaderboardSettings.layoutSettings.overrideCssEnabled &&
                    props.leaderboardSettings.layoutSettings.overrideCss) && setStyle(`
                ${props.leaderboardSettings.layoutSettings.overrideCss.split('.scoreboard-container').join(`.scoreboard-id-${scoreboardInstanceSettingsId} .scoreboard-container`)}`)
            }
        </>)
}
export const LeaderboardDataGrid: FC<LeaderboardDataGridProps> = props => {
    if (!props.leaderboardSettings) {
        return (<div className="scoreboard-container" />)
    }

    const { scoreboardInstanceSettingsId } = props.leaderboardSettings
    const layoutSettings = props.leaderboardSettings.layoutSettings
    const showAllVerbiage = props.leaderboardSettings.layoutSettings.showAllVerbiage
    const data = props.data ? props.data : []
    const dataList = props.overrideDisplayLimit ? data : data.slice(0, layoutSettings.displayLimit)

    return (
        <div>
            <RenderStyles {...props} leaderboardSettings={props.leaderboardSettings} />
            <div className="leaderboard">
                <div className={`scoreboard-id-${scoreboardInstanceSettingsId}`}>
                    <div className="scoreboard-container">
                        {
                            props.showTitle &&
                            <h2>{props.leaderboardSettings.moduleTitle}</h2>
                        }
                        {
                            props.showSubTitle &&
                            <h3>{props.leaderboardSettings.moduleSubTitle}</h3>
                        }
                        {props.data && props.showModule && props.leaderboardSettings &&
                            <div className="data-grid-container">
                                <LeaderboardHeaderRow layoutSettings={layoutSettings} sortLeaderboard={props.sortLeaderboard} scoreboardTypeId={props.leaderboardSettings.scoreboardTypeId} sortedColumn={{ column: props.sortedColumn.column, direction: props.sortedColumn.sortAscending ? 'Ascending' : 'Descending' }} />
                                <div className="data-grid-rows">
                                    {dataList.map((row, index) => (
                                        <DataGridRow key={index} data={row} rank={row.rank} leaderboardSettings={props.leaderboardSettings!} />)
                                    )}
                                    {dataList.map((row, index) => (
                                        <MobileDataGridRow key={index} data={row} rank={row.rank} leaderboardSettings={props.leaderboardSettings!} />)
                                    )}
                                    {data.length > layoutSettings.displayLimit &&
                                        <ShowAllRow
                                            showAllVerbiage={showAllVerbiage}
                                            overrideDisplayLimit={props.overrideDisplayLimit}
                                            toggleOverrideDisplayLimit={props.toggleOverrideDisplayLimit}
                                        />}
                                </div >
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

LeaderboardDataGrid.displayName = 'LeaderboardDataGrid'
